import React from 'react';
import { Button, Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';

const { Option } = Select;

export default (t, onPermissionTypeChange, allAvailableRules = []) => {
  const availableRuleIds = new Set(allAvailableRules.map(r => r.id));
  const availableContentRefs = new Set(
    allAvailableRules.map(r => r.whatDetail?.content).filter(Boolean),
  );

  const isCTA = record => record.type === 'cta' || (!record.type && record.callToAction);
  const isRule = record => record.type === 'rule' || (!record.type && record.rule);

  return [
    {
      title: t('pathways:ProcedurePathways.wizard.careTeamRules.columns.itemName'),
      dataIndex: 'rule',
      key: 'itemName',
      ellipsis: true,
      render: (rule, record) => {
        if (isCTA(record)) {
          return record.callToAction?.name;
        }

        if (isRule(record) && record.id && !availableRuleIds.has(record.id)) {
          return (
            <p className="rule-status-text">
              {t('pathways:ProcedurePathways.wizard.careTeamRules.ruleRemoved')}
            </p>
          );
        }

        return rule?.name;
      },
    },
    {
      title: t('pathways:ProcedurePathways.wizard.careTeamRules.columns.value'),
      dataIndex: 'rule',
      key: 'value',
      render: (rule, record) => {
        if (isCTA(record)) {
          return record.contentRef || record.callToAction?.value;
        }

        if (isRule(record) && record.id && !availableRuleIds.has(record.id)) {
          return null;
        }

        if (isRule(record) && record.contentRef && !availableContentRefs.has(record.contentRef)) {
          return (
            <p className="rule-status-text">
              {t('pathways:ProcedurePathways.wizard.careTeamRules.contentMismatch')}
            </p>
          );
        }

        return rule?.whatDetail?.name || rule?.whatDetail?.latestVersion?.name;
      },
    },
    {
      title: t('pathways:ProcedurePathways.wizard.careTeamRules.columns.audience'),
      dataIndex: 'rule',
      key: 'audience',
      width: 120,
      render: (rule, record) => {
        let audience;

        if (isCTA(record)) {
          audience = record.callToAction?.audience;
        } else {
          audience = rule?.audienceType;
        }

        if (!audience) return null;

        const audienceKey = `pathways:ProcedurePathways.wizard.careTeamRules.callToAction.audience.${audience}`;
        return t(audienceKey);
      },
    },
    {
      title: t('pathways:ProcedurePathways.wizard.careTeamRules.columns.permissionType'),
      dataIndex: 'permissionType',
      key: 'permissionType',
      width: 250,
      render: (permissionType, record) => (
        <Select
          style={{ width: '100%' }}
          value={permissionType}
          onChange={value => onPermissionTypeChange(record.id || record.rule?.id, value)}
        >
          <Option value="send_notification">
            {t('pathways:ProcedurePathways.wizard.careTeamRules.permissionTypes.send_notification')}
          </Option>
          <Option value="view_data">
            {t('pathways:ProcedurePathways.wizard.careTeamRules.permissionTypes.view_data')}
          </Option>
          <Option value="create_data">
            {t('pathways:ProcedurePathways.wizard.careTeamRules.permissionTypes.create_data')}
          </Option>
        </Select>
      ),
    },
    {
      title: t('common:buttons.delete'),
      dataIndex: 'onDelete',
      key: 'delete',
      width: 150,
      render: onDelete => (
        <Button onClick={onDelete}>
          <FontAwesomeIcon icon={faTrashAlt} /> {t('common:buttons.delete')}
        </Button>
      ),
    },
  ];
};
